import React from "react";
import Dimensions from "react-dimensions";
import { VictoryChart, VictoryLegend, VictoryLine, VictoryTheme } from "victory";
import { instantFromApi } from "../utils/dateTime";

class VolumeStatsChart extends React.Component {
  render() {
    const { volumeData, exchange } = this.props;

    const legend = [
      {
        name: exchange,
        symbol: { fill: "#7992d0" },
      },
    ];

    return (
      <VictoryChart
        scale={{ x: "time", y: "linear" }}
        width={this.props.containerWidth}
        height={300}
        domainPadding={10}
        theme={VictoryTheme.material}
      >
        <VictoryLine
          data={volumeData}
          style={{
            data: { stroke: "#7992d0" },
          }}
          x={d => instantFromApi(d.date).toEpochMilli()}
          y={d => d.volumeAvg}
        />
        <VictoryLegend
          x={125}
          y={50}
          title={"Average volume"}
          centerTitle
          orientation="horizontal"
          gutter={20}
          style={{ border: { stroke: "black" }, title: { fontSize: 12 } }}
          data={legend}
        />
      </VictoryChart>
    );
  }
}

export default Dimensions()(VolumeStatsChart);



// WEBPACK FOOTER //
// ./src/charts/VolumeStatsChart.js